//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.core')
        .factory('fileDownloadService', fileDownloadService)
    ;

    function fileDownloadService($window) {
        var service = {
            createDownload: createDownload
        };
        return service;

        function createDownload(data, fileName, contentType) {
            var blob = b64ToBlob(data, contentType);

            if (navigator.msSaveBlob)
                navigator.msSaveBlob(blob, fileName);

            else {
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                if (urlCreator) {
                    var url = urlCreator.createObjectURL(blob);
                    provideFile(url, fileName);
                }
                else {
                    throw "Not supported";
                }

            }
        }

        function b64ToBlob(data, contentType) {
            var byteCharacters = atob(data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        }

        function provideFile(url, fileName) {
            var link = document.createElement("a");

            if ("download" in link) {
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                var event = document.createEvent('MouseEvents');
                event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                link.dispatchEvent(event);
            } else {
                $window.location = url;
            }
        }
    }

})();